export class InitialRegistrationSettingsDTO {
    emailNotRequired: boolean;
    showUserName: boolean;

    constructor(set?) {
        set = set || {};

        this.emailNotRequired = set.emailNotRequired || false;
        this.showUserName = set.showUserName || false;
    }
}
